import React from 'react';

const FinalValidation = () => {
  return (
    <div class="relative py-16">
      <div className="relative max-w-screen-lg mx-auto">
        <div class="py-2">
          <div class="flex items-center">
            <input
              id="remember_me_a"
              type="checkbox"
              required
              class="mr-4 form-checkbox h-8 w-8 bg-gray-200 text-black transition duration-150 ease-in-out"
            />
            <div for="remember_me" class="ml-2 block text-xs md:text-xl text-gray-500">
              <p>
                By clicking here, you agree to the terms of the Hybrid Power{' '}
                <a href="#" class="text-black underline">
                  <strong>Terms of Service</strong>
                </a>{' '}
                and{' '}
                <a href="#" class="text-black underline">
                  <strong>Privacy Policy</strong>
                </a>{' '}
              </p>
            </div>
          </div>
          <div class="mt-10 flex items-center">
            <input
              id="remember_me_a"
              type="checkbox"
              required
              class="mr-4 form-checkbox h-8 w-8 bg-gray-200 text-black transition duration-150 ease-in-out"
            />
            <div for="remember_me" class="ml-2 block text-xs md:text-xl text-gray-500">
              <p>
                By clicking here, you attest that you are over the age of 18 and have the legal
                authority to make changes on or setup this energy account.
              </p>
            </div>
          </div>
          <div class="mt-10 flex items-center">
            <input
              id="remember_me_a"
              type="checkbox"
              required
              class="mr-4 form-checkbox h-8 w-8 bg-gray-200 text-black transition duration-150 ease-in-out"
            />
            <div for="remember_me" class="ml-2 block text-xs md:text-xl text-gray-500">
              <p>
                By clicking here, you understand that Hybrid Power is 100% paperless billing and
                that you will need to setup online bill pay before your account can be activated
                (next step).
              </p>
            </div>
          </div>
          <div class="mt-10 flex items-center">
            <input
              id="remember_me_a"
              type="checkbox"
              required
              class="mr-4 form-checkbox h-8 w-8 bg-gray-200 text-black transition duration-150 ease-in-out"
            />
            <div for="remember_me" class="ml-2 block text-xs md:text-xl text-gray-500">
              <p>
                Click here to allow Hybrid Power to contact you of billing adjustments, savings
                offers, and other marketing material.
              </p>
            </div>
          </div>
          <div class="mt-10 flex items-center">
            <input
              id="remember_me_a"
              type="checkbox"
              required
              class="mr-4 form-checkbox h-8 w-8 bg-gray-200 text-black transition duration-150 ease-in-out"
            />
            <div for="remember_me" class="ml-2 block text-xs md:text-xl text-gray-500">
              <p>
                By clicking here, you understand and allow Hybrid Power to run a soft credit check
                on your account and this DOES NOT affect your credit score.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="max-w-screen-lg mx-auto pt-20">
        <div class="text-center block text-sm font-bold text-gray-700">
          Sign before submitting form
        </div>
        <div class="max-w-screen-lg mx-auto flex items-center">
          <div class="py-10 w-2/3 border-solid border-4 border-yellow text-center ">
            SIGNATURE BOX HERE
          </div>
          <div class="w-2/3 py-10">
            <div class="relative ml-10">
              <span class="rounded-md shadow-sm">
                <button
                  type="button"
                  class="inline-flex items-center px-20 pt-6 pb-5 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-black hover:bg-opacity-75 focus:outline-none focus:border-black focus:shadow-outline-black active:bg-black transition ease-in-out duration-150"
                >
                  <svg
                    class="-ml-1 mr-3 h-12 w-12"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M8.011 6.215c-1.711-.009-3.86.918-5.499 2.557-.625.625-1.176 1.355-1.601 2.174 1.479-1.119 3.057-1.47 4.903-.434.544-1.437 1.27-2.9 2.197-4.297zm9.785 9.773c-1.516.991-3.007 1.706-4.297 2.21 1.036 1.848.686 3.424-.434 4.902.819-.424 1.549-.975 2.175-1.602 1.644-1.642 2.572-3.796 2.556-5.51zm6.152-15.946c-.412-.028-.816-.042-1.213-.042-8.602 0-13.498 6.558-15.28 11.833l4.728 4.729c5.428-1.946 11.817-6.661 11.817-15.172 0-.439-.017-.888-.052-1.348zm-9.888 9.91c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0 .391 1.023 0 1.414-1.024.39-1.414 0zm2.828-2.828c-.781-.78-.781-2.047 0-2.828s2.048-.781 2.828 0c.781.781.781 2.047 0 2.828s-2.047.781-2.828 0zm-14.919 12.454l-.906-.906 5.208-5.188.906.906-5.208 5.188zm4.979 1.857l-.906-.906 3.636-3.664.906.906-3.636 3.664zm-6.042 2.565l-.906-.906 6.448-6.438.906.906-6.448 6.438z" />
                  </svg>
                  <div class="">
                    {' '}
                    <h2 class="text-2xl"> JOIN HYBRID POWER</h2>
                  </div>

                  <svg
                    class="ml-5 h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
                  </svg>
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="pt-10 text-center block text-sm text-gray-400">
          Already have an account? <strong>Log in | Reset form</strong>
        </div>
      </div>
    </div>
  );
};

export default FinalValidation;
